import { message, notification } from 'ant-design-vue'

message.config({
  duration: 1.5,
  top: '30px',
  maxCount: 3
})

notification.config({
  duration: 3,
  top: '30px',
  placement: 'topLeft'
})
